import React, { useState } from "react";
import { Link2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";

// Dialog afișat la salvare când textul nu are legături interne: autoarea alege ce linkuri intră.
export const SaveLinksDialog = ({ suggestions, onConfirm, onSkip }) => {
  const [selected, setSelected] = useState(() => suggestions.map(() => true));
  const toggle = (i) => setSelected((prev) => prev.map((v, j) => (j === i ? !v : v)));
  const chosen = suggestions.filter((_, i) => selected[i]);

  return (
    <Dialog open onOpenChange={(open) => !open && onSkip()}>
      <DialogContent data-testid="save-links-dialog" className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-light">Însemnarea nu are nicio legătură internă</DialogTitle>
          <DialogDescription>
            Am găsit însemnări mai vechi care se leagă firesc de textul acesta. Linkurile între însemnări ajută cititorii
            să descopere mai mult și ajută Google să înțeleagă blogul.
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {suggestions.map((s, i) => (
            <li key={s.slug} className="flex items-start gap-3 rounded-xl bg-[var(--tint-mint)] px-3.5 py-3">
              <Checkbox
                id={`save-link-${i}`}
                data-testid={`save-link-check-${i}`}
                checked={selected[i]}
                onCheckedChange={() => toggle(i)}
                className="mt-0.5"
              />
              <label htmlFor={`save-link-${i}`} className="min-w-0 flex-1 cursor-pointer">
                <span className="flex items-center gap-1.5 font-serif text-[15px] text-[var(--milk)]">
                  <Link2 className="h-3.5 w-3.5 shrink-0" strokeWidth={1.8} /> {s.title}
                </span>
                {s.anchor_text && (
                  <span className="mt-0.5 block text-xs text-[#F7F1E8]/78">
                    pe expresia <em>„{s.anchor_text}”</em>
                  </span>
                )}
              </label>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            type="button"
            onClick={onSkip}
            data-testid="save-links-skip-btn"
            className="rounded-full border border-[color-mix(in_srgb,var(--milk)_20%,transparent)] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-[var(--milk)]"
          >
            Salvează fără linkuri
          </button>
          <button
            type="button"
            onClick={() => onConfirm(chosen)}
            disabled={chosen.length === 0}
            data-testid="save-links-confirm-btn"
            className="rounded-full bg-[var(--teal)] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-white disabled:opacity-50"
          >
            Inserează {chosen.length > 0 ? `${chosen.length} ` : ""}și salvează
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveLinksDialog;
